var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpAttive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.959,
    height: 20.959,
    viewBox: "0 0 20.959 20.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-active-3419249",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9570",
    "data-name": "Tracciato 9570",
    d: "M16.479,6A10.479,10.479,0,1,0,26.959,16.479,10.479,10.479,0,0,0,16.479,6Zm.806,15.316a.806.806,0,0,1-1.612,0V11.643a.806.806,0,0,1,1.612,0Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpAttive);
export default __webpack_public_path__ + "static/media/OpAttive.420b200b7674176c5d6becdcb495e56c.svg";
export { ForwardRef as ReactComponent };